import { JsonProperty } from "../requests/jsonparser";
import { Podcast } from "./podcast";
import { PodcastCategory } from "./podcast_category";

export class PodcastResponse {

    @JsonProperty({ type: 'true' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'PodcastResponse' })
    MODELNAME: string;

    @JsonProperty({ clazz: PodcastCategory, type: 'PodcastCategory' })
    categories: PodcastCategory[]

    @JsonProperty({ clazz: Podcast, type: 'Podcast' })
    featured: Podcast[]
}



// WEBPACK FOOTER //
// ./src/api/src/models/podcast_response.ts